import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function fetchPrograms() {
  const { data } = await api.get("/programs");
  return data.items;
}
export async function fetchProgram(slug) {
  const { data } = await api.get(`/programs/${slug}`);
  return data;
}
export async function fetchCamps() {
  const { data } = await api.get("/camps");
  return data.items;
}
export async function fetchCamp(slug) {
  const { data } = await api.get(`/camps/${slug}`);
  return data;
}
export async function postLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}
export async function postInquiry(payload) {
  const { data } = await api.post("/inquiries", payload);
  return data;
}
export async function postCampRegistration(payload) {
  const { data } = await api.post("/camp-registrations", payload);
  return data;
}
export async function postNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}

export async function fetchHomepageContent() {
  const { data } = await api.get("/site/homepage");
  return data;
}
export async function fetchFaqs() {
  const { data } = await api.get("/site/faqs");
  return data.items;
}
export async function fetchTestimonials() {
  const { data } = await api.get("/site/testimonials");
  return data.items;
}
export async function fetchContactInfo() {
  const { data } = await api.get("/site/contact-info");
  return data;
}
export async function fetchSitePrograms() {
  const { data } = await api.get("/site/programs");
  return data.items;
}
export async function fetchSiteProgram(slug) {
  const { data } = await api.get(`/site/programs/${slug}`);
  return data;
}
export async function fetchSiteCamps() {
  const { data } = await api.get("/site/camps");
  return data.items;
}
export async function fetchSiteCamp(slug) {
  const { data } = await api.get(`/site/camps/${slug}`);
  return data;
}
export async function fetchReviewStats() {
  const { data } = await api.get("/site/review-stats");
  return data;
}
